import { GET, POST } from "@/services/request";
import * as APIs from '@/services/APIs';

/**
 * 获取预约列表
 */
export const fetchList = async (params) => {
  const res = await GET(APIs.API_SUBSCRIBE_MARGIN_LIST, { params });
  return res.data.data ?? {};
};

/**
 * 添加修改余量
 */
export const fetchAddUpdate = async (data) => {
  const res = await POST(APIs.API_SUBSCRIBE_MARGIN_UPDATE, { data });
  return res.data ?? {};
};

/**
 * 删除余量
 */
export const fetchDel = async (data) => {
  const res = await POST(APIs.API_SUBSCRIBE_MARGIN_DEL, { data });
  return res.data ?? {};
};

/**
 * 获取服务余量设置列表
 */
export const fetchOptionResidueList = async (params) => {
  const res = await GET(APIs.API_SUBSCRIBE_OPTIONRESIDUELIST, { params });
  return res.data.data ?? {};
};
